import { sessionProtectionToken } from './sessionProtection';
import { useEffect } from 'react';
import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
let subscribers = 0;
let connection: ReturnType<HubConnectionBuilder['build']> | null = null;
export function useGovernanceRefresh(refresh: () => void | Promise<void>) {
  useEffect(() => {
    const listener = () => { if (document.visibilityState === 'visible') void refresh(); };
    window.addEventListener('governance-changed', listener);
    const timer = window.setInterval(listener, 30_000);
    if (++subscribers === 1) {
      const headers: Record<string, string> = {};
      connection = new HubConnectionBuilder().withUrl('/api/governance/changes', { headers }).withAutomaticReconnect().configureLogging(LogLevel.None).build();
      connection.on('collaboration-changed', () => window.dispatchEvent(new Event('governance-changed')));
      connection.on('changed', () => window.dispatchEvent(new Event('governance-changed')));
      const startedConnection = connection;
      void sessionProtectionToken().then(async token => {
        if (connection !== startedConnection || subscribers === 0) return;
        // The negotiation POST follows the same CSRF contract as all write APIs.
        headers.RequestVerificationToken = token;
        return startedConnection.start();
      }).catch(() => { /* Visible-page polling keeps data fresh if the realtime channel is unavailable. */ });
    }
    return () => {
      window.removeEventListener('governance-changed', listener); window.clearInterval(timer);
      if (--subscribers === 0) { void connection?.stop(); connection = null; }
    };
  }, [refresh]);
}
